.tabs {
  -webkit-tap-highlight-color: transparent;

  height: 100%;
}
